import Classifieds from ".";
import TabsNavigation from "../../../../../components/elements/TabsNavigation";
import ManageClassified from "../../../../../components/sections/admin/Classified/ManageClassified";
import ClassifiedCategory from "../ClassifiedCategory";
import ClassifiedTags from "../ClassifiedTags";

const tabRoutes = [
  {
    label: "List",
    icon: "fa-regular fa-cloud",
    path: "/admin/classifieds",
  },
  {
    label: "Categories",
    icon: "fa-regular fa-layer-group",
    path: "/admin/classifieds-categories",
  },
  {
    label: "Tags",
    icon: "fa-regular fa-tags",
    path: "/admin/classifieds-tags",
  },
  {
    label: "Comments",
    icon: "fa-regular fa-comments",
    path: "/admin/classifieds-comment",
  },
];

export const classifiedRoutes = () => [
  {
    path: "/admin/classifieds",
    component: () => (
      <TabsNavigation title="Classifieds Management" tabRoutes={tabRoutes}>
        <Classifieds />
      </TabsNavigation>
    ),
    layout: "admin",
    routeType: "admin",
    title: "Classifieds Management",
  },
  {
    path: "/admin/classifieds-categories",
    component: () => (
      <TabsNavigation title="Classifieds Management" tabRoutes={tabRoutes}>
        <ClassifiedCategory />
      </TabsNavigation>
    ),
    layout: "admin",
    routeType: "admin",
    title: "Classifieds Management",
  },
  {
    path: "/admin/classifieds-tags",
    component: () => (
      <TabsNavigation title="Classifieds Management" tabRoutes={tabRoutes}>
        <ClassifiedTags />
      </TabsNavigation>
    ),
    layout: "admin",
    routeType: "admin",
    title: "Classifieds Management",
  },
  {
    path: "/admin/manage-classifieds",
    component: ManageClassified,
    layout: "admin",
    routeType: "admin",
    title: "Manage Classifieds",
  },
  {
    path: `/admin/manage-classifieds/:id`,
    component: ManageClassified,
    layout: "admin",
    routeType: "admin",
    title: "Manage Classifieds",
  },
];
